
const globalRouter = { navigate: null } ;

export default globalRouter;
